import videojs from 'video.js';
import { PixelsJS } from '../../types/pixelsjs';
import { log } from '../../services/logs';

const { pixelsjs } = window;
const Plugin: typeof videojs.Plugin = pixelsjs.getPlugin('plugin');

class PixelsHeaderBidding extends Plugin {
  currentPlayer: PixelsJS;
  options: Record<string, any>;
  pbjs: any;

  constructor(player, options) {
    super(player);
    this.currentPlayer = player;
    this.options = options;

    if (options.bidConfig && window.vistaprebid) {
      this.pbjs = window.vistaprebid || {};
      this.pbjs.que = this.pbjs.que || [];

      this.pbjs.que.push(() => {
        this.pbjs.addAdUnits({
          code: this.currentPlayer.id(),
          mediaTypes: {
            video: {
              context: 'instream',
              playerSize: [640, 480],
              mimes: ['video/mp4'],
              playbackmethod: [2],
              maxduration: 30,
              protocols: [2, 3, 5, 6, 7, 8],
              api: [1, 2],
              linearity: 1,
              skip: 0
            }
          },
          bids: options.bidConfig
        });

      });

    }
  }

  public async getAdTagUrl() {
    return new Promise(
      (resolve) => {
        if (!this.options.bidConfig) {
          log('pixels', 'header-bidding: no config, continue with no bid request');
          resolve(this.options.adTagUrl);
          return;
        }

        log('pixels', 'header-bidding: bid config found, make prebid request');

        this.pbjs.que.push(() => {
          this.pbjs.requestBids({
            timeout: 3000,
            bidsBackHandler: async (bids) => {
              log('pixels', 'header-bidding: bid response', bids);
              resolve(await this._attachBidResponse(bids));
            }
          })
        });
      });
  }

  private async _attachBidResponse(bids: Record<string, any>) {
     const bidderParams = Object.entries(bids)
    .map(([key, value]) => `${key}=${value as string}`)
    .join('&');

    const url = new URL(this.options.adTagUrl);
    const searchParams = url.searchParams;
    const defaultCutomParams = searchParams.get('cust_params') ? `${searchParams.get('cust_params')}&` : '';

    searchParams.set('cust_params', `${defaultCutomParams}${bidderParams}`);

    return url.toString();
  };

}

pixelsjs.registerPlugin('pixelsHerderBidding', PixelsHeaderBidding);
